import { MEMORY_HIDDEN_TEXT, type MemoryPart } from '@contracts/assistant-memory';
import { ObjectChip } from '../ObjectChip';

/**
 * A note's text as the server resolved it for this reader (§9.7, D170): plain text, an object as its chip under the
 * name the server gave it, or the hidden-object words. The server already checked the reader's rights, so no second
 * resolve is asked for; a raw `{{…}}` token never reaches here.
 */
export function MemoryText({ parts }: { parts: readonly MemoryPart[] }) {
  return (
    <>
      {parts.map((part, i) => {
        if ('text' in part) return <span key={i}>{part.text}</span>;
        if ('hidden' in part) {
          return (
            <span key={i} data-memory-hidden="" className="font-normal italic text-[hsl(var(--h-muted-foreground))]">
              {MEMORY_HIDDEN_TEXT}
            </span>
          );
        }
        const { type, id, label } = part.ref;
        return <ObjectChip key={i} objectRef={{ type, id }} resolved={{ type, id, label, href: null }} />;
      })}
    </>
  );
}
